import script from "./WelcomeMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WelcomeMessage.vue?vue&type=script&lang=ts&setup=true"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=10cd4a0b&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10cd4a0b"]])

export default __exports__